import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconShoppingBag_9 = function IconShoppingBag_9(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70473 12.2622C8.11215 12.1875 8.50299 12.4572 8.57768 12.8646L9.16446 16.0653H27.1553C27.3776 16.0653 27.5886 16.1639 27.7311 16.3347C27.8736 16.5054 27.9329 16.7306 27.8932 16.9494L25.9855 27.4417C25.9206 27.7983 25.61 28.0575 25.2476 28.0575H10.463C10.101 28.0575 9.79062 27.7989 9.72533 27.4427L7.10227 13.1351C7.02758 12.7277 7.29731 12.3369 7.70473 12.2622ZM9.43946 17.5653L11.088 26.5575H24.6216L26.2566 17.5653H9.43946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9482 32.3154C15.9482 33.2374 15.2008 33.9849 14.2788 33.9849C13.3568 33.9849 12.6094 33.2374 12.6094 32.3154C12.6094 31.3934 13.3568 30.646 14.2788 30.646C15.2008 30.646 15.9482 31.3934 15.9482 32.3154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5791 32.3154C23.5791 33.2374 22.8317 33.9849 21.9097 33.9849C20.9877 33.9849 20.2402 33.2374 20.2402 32.3154C20.2402 31.3934 20.9877 30.646 21.9097 30.646C22.8317 30.646 23.5791 31.3934 23.5791 32.3154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3477 13C11.3477 12.5858 11.6834 12.25 12.0977 12.25H15.8512C16.2654 12.25 16.6012 12.5858 16.6012 13V16.7536C16.6012 17.1678 16.2654 17.5036 15.8512 17.5036H12.0977C11.6834 17.5036 11.3477 17.1678 11.3477 16.7536V13ZM12.8477 13.75V16.0036H15.1012V13.75H12.8477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 9C13.25 8.58579 13.5858 8.25 14 8.25H17.7536C18.1678 8.25 18.5036 8.58579 18.5036 9V12.7536C18.5036 13.1678 18.1678 13.5036 17.7536 13.5036H14C13.5858 13.5036 13.25 13.1678 13.25 12.7536V9ZM14.75 9.75V12.0036H17.0036V9.75H14.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 5C15.25 4.58579 15.5858 4.25 16 4.25H19.7536C20.1678 4.25 20.5036 4.58579 20.5036 5V8.75356C20.5036 9.16778 20.1678 9.50356 19.7536 9.50356H16C15.5858 9.50356 15.25 9.16778 15.25 8.75356V5ZM16.75 5.75V8.00356H19.0036V5.75H16.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 9C17.25 8.58579 17.5858 8.25 18 8.25H21.7536C22.1678 8.25 22.5036 8.58579 22.5036 9V12.7536C22.5036 13.1678 22.1678 13.5036 21.7536 13.5036H18C17.5858 13.5036 17.25 13.1678 17.25 12.7536V9ZM18.75 9.75V12.0036H21.0036V9.75H18.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6233 3.55482C22.8691 3.22143 23.3386 3.15045 23.672 3.39627L26.6931 5.62388C27.0265 5.8697 27.0975 6.33924 26.8516 6.67262L24.624 9.69371C24.3782 10.0271 23.9087 10.0981 23.5753 9.85226L20.5542 7.62465C20.2208 7.37883 20.1498 6.90929 20.3957 6.57591L22.6233 3.55482ZM23.3855 5.04866L22.048 6.86246L23.8618 8.19987L25.1993 6.38607L23.3855 5.04866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24505 7.6219C8.45381 7.26414 8.91307 7.14336 9.27083 7.35212L12.5128 9.24389C12.8706 9.45265 12.9914 9.9119 12.7826 10.2697L10.8908 13.5116C10.6821 13.8694 10.2228 13.9902 9.86504 13.7814L6.62306 11.8897C6.26531 11.6809 6.14452 11.2216 6.35328 10.8639L8.24505 7.6219ZM9.16262 9.02567L8.02684 10.9721L9.97325 12.1079L11.109 10.1615L9.16262 9.02567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1016 13C15.1016 12.5858 15.4373 12.25 15.8516 12.25H19.6051C20.0193 12.25 20.3551 12.5858 20.3551 13V16.7536C20.3551 17.1678 20.0193 17.5036 19.6051 17.5036H15.8516C15.4373 17.5036 15.1016 17.1678 15.1016 16.7536V13ZM16.6016 13.75V16.0036H18.8551V13.75H16.6016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 13C19.25 12.5858 19.5858 12.25 20 12.25H23.7536C24.1678 12.25 24.5036 12.5858 24.5036 13V16.7536C24.5036 17.1678 24.1678 17.5036 23.7536 17.5036H20C19.5858 17.5036 19.25 17.1678 19.25 16.7536V13ZM20.75 13.75V16.0036H23.0036V13.75H20.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 14.75C36.5 19.0302 33.0302 22.5 28.75 22.5C24.4698 22.5 21 19.0302 21 14.75C21 10.4698 24.4698 7 28.75 7C33.0302 7 36.5 10.4698 36.5 14.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8251 18.4746C30.7383 18.4746 31.8044 17.1693 31.8044 14.8376V14.5188C31.8044 12.4661 30.8578 11.1409 28.8949 11.1409C27.191 11.1409 26.1348 12.1373 26.1348 13.612C26.1348 15.0568 27.1412 15.9138 28.5162 15.9138C29.3732 15.9138 29.8913 15.565 30.2201 15.0469C30.1902 16.5017 29.7219 17.249 28.7753 17.249C28.0977 17.249 27.8088 16.9401 27.7091 16.4518H26.2045C26.3639 17.7372 27.2807 18.4746 28.8251 18.4746ZM28.8749 14.8376C28.1575 14.8376 27.6992 14.3195 27.6992 13.5722C27.6992 12.8248 28.1675 12.3067 28.8749 12.3067C29.6023 12.3067 30.0906 12.8149 30.0906 13.6419C30.0906 14.3394 29.6023 14.8376 28.8749 14.8376Z",
    fill: "white"
  }));
};

export { IconShoppingBag_9 };